import { render } from "./DisabledCheckbox.vue?vue&type=template&id=49dada1e"
import script from "./DisabledCheckbox.vue?vue&type=script&lang=ts"
export * from "./DisabledCheckbox.vue?vue&type=script&lang=ts"
script.render = render

export default script